import React from 'react';
import { useTranslation } from 'react-i18next';
import './LandingHeader.css';

export const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <div className="hero-section">
      <h1 className="main-title-large">
        <span className="accent-large">{t('landing.title')}</span>
      </h1>
      <div className="hero-badge-large">{t('landing.badge')}</div>
      <p className="tagline-large">{t('landing.tagline')}</p>
    </div>
  );
};

export const ROIDisplay = () => {
  const { t } = useTranslation();

  return (
    <div className="roi-display">
      <div className="roi-main-row">
        <div className="roi-number-block">
          <div className="roi-big-number">{t('landing.roi.number')}</div>
          <div className="roi-text-block">
            <div className="roi-big-text">{t('landing.roi.text')}</div>
            <div className="roi-subtext">{t('landing.roi.subtext')}</div>
          </div>
        </div>
        <div className="roi-arrow-wrapper">
          <div className="roi-arrow-circle">
            <span className="roi-arrow-icon">↑</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const VisualStats = () => {
  const { t } = useTranslation();

  return (
    <div className="visual-stats">
      <div className="visual-stat">
        <div className="stat-big">10,000+</div>
        <div className="stat-small">{t('landing.stats.fraudIps')}</div>
      </div>
      <div className="visual-stat">
        <div className="stat-big">50+</div>
        <div className="stat-small">{t('landing.stats.campaigns')}</div>
      </div>
    </div>
  );
};

export default HeroSection;

